<aside class="sk-cat">
  <div class="sk-search">
    <input
      #searchInput
      type="search"
      [ngModel]="query"
      (ngModelChange)="onQueryChange($event)"
      [placeholder]="'skillManagement.catalog.searchPlaceholder' | translate"
      [attr.aria-label]="'skillManagement.catalog.searchLabel' | translate"
    />
    <span class="sk-search__icon"
      ><app-skill-icon name="search" [size]="20"
    /></span>
  </div>

  @if (missingEnCount > 0 && !searching) {
    <button
      type="button"
      class="sk-miss"
      (click)="jumpToNextMissingEnglish()"
      [title]="'skillManagement.catalog.missingEnJump' | translate"
    >
      <span>{{
        (missingEnCount === 1
          ? 'skillManagement.catalog.missingEnOne'
          : 'skillManagement.catalog.missingEn'
        ) | translate: { count: missingEnCount }
      }}</span>
      <span class="sk-miss__next">{{
        'skillManagement.catalog.missingEnNext' | translate
      }}</span>
    </button>
  }

  @if (searching) {
    <div class="sk-hits">
      <div class="sk-hits__count" role="status">
        {{
          'skillManagement.catalog.hits'
            | translate: { hits: hits.length, categories: hitCategoryCount }
        }}
      </div>
      @for (skill of hits; track skill.id) {
        <button
          type="button"
          class="sk-hit"
          [class.sk-hit--on]="skill.id === selectedId"
          [attr.aria-current]="skill.id === selectedId ? 'true' : null"
          (click)="selectSkill.emit(skill.id!)"
        >
          <span class="sk-hit__name">
            @for (part of parts(skill.faehigkeit); track $index) {
              @if (part.match) {
                <mark class="sk-hl">{{ part.text }}</mark>
              } @else {
                <span>{{ part.text }}</span>
              }
            }
            @if (showEnglishName(skill)) {
              <span class="sk-hit-en">
                ·
                @for (part of parts(skill.faehigkeitEn); track $index) {
                  @if (part.match) {
                    <mark class="sk-hl">{{ part.text }}</mark>
                  } @else {
                    <span>{{ part.text }}</span>
                  }
                }
              </span>
            }
          </span>
          <span class="sk-hit-cat">
            <span>{{ skill.kategorie }}</span>
            @if (!hasEnglishName(skill.faehigkeitEn)) {
              <span class="sk-noen">{{
                'skillManagement.catalog.enMissing' | translate
              }}</span>
            }
          </span>
          <span
            class="sk-n"
            [title]="'skillManagement.catalog.assignments' | translate"
            >{{ count(skill) }}</span
          >
        </button>
      }
      @if (hits.length === 0) {
        <div class="sk-empty">
          {{ 'skillManagement.catalog.noHits' | translate }}
        </div>
      }
    </div>
  } @else {
    <div class="sk-acc">
      @for (group of groups; track group.key) {
        <div class="sk-acc__item" [class.sk-acc__item--open]="isOpen(group)">
          <button
            type="button"
            class="sk-acc__head"
            [attr.aria-expanded]="isOpen(group)"
            [attr.aria-controls]="groupId(group)"
            (click)="toggle(group)"
          >
            <span class="sk-acc__chev"
              ><app-skill-icon name="chevron" [size]="17"
            /></span>
            <span class="sk-acc__title">
              <span>{{ group.kategorie }}</span>
              @if (hasEnglishName(group.kategorieEn)) {
                <span class="sk-acc__en">{{ group.kategorieEn }}</span>
              } @else {
                <span class="sk-noen sk-acc__noen">{{
                  'skillManagement.catalog.enMissing' | translate
                }}</span>
              }
            </span>
            <span class="sk-acc__count">{{ group.skills.length }}</span>
          </button>
          @if (isOpen(group)) {
            <div class="sk-acc__body" [id]="groupId(group)">
              @for (skill of group.skills; track skill.id) {
                <button
                  type="button"
                  class="sk-item"
                  [class.sk-item--on]="skill.id === selectedId"
                  [attr.aria-current]="skill.id === selectedId ? 'true' : null"
                  (click)="selectSkill.emit(skill.id!)"
                >
                  <span>
                    <span>{{ skill.faehigkeit }}</span>
                    @if (!hasEnglishName(skill.faehigkeitEn)) {
                      <span class="sk-noen">{{
                        'skillManagement.catalog.enMissing' | translate
                      }}</span>
                    }
                  </span>
                  @if (count(skill) > 0) {
                    <span
                      class="sk-n"
                      [title]="
                        'skillManagement.catalog.assignments' | translate
                      "
                      >{{ count(skill) }}</span
                    >
                  }
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</aside>
